var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calculator",
    "data-name": "Icon awesome-calculator",
    d: "M12.5,0H1.5A1.538,1.538,0,0,0,0,1.5v13A1.538,1.538,0,0,0,1.5,16h11A1.538,1.538,0,0,0,14,14.5V1.5A1.538,1.538,0,0,0,12.5,0ZM4,13.6a.43.43,0,0,1-.4.4H2.4a.43.43,0,0,1-.4-.4V12.4a.43.43,0,0,1,.4-.4H3.6a.43.43,0,0,1,.4.4Zm0-4a.43.43,0,0,1-.4.4H2.4A.43.43,0,0,1,2,9.6V8.4A.43.43,0,0,1,2.4,8H3.6a.43.43,0,0,1,.4.4Zm4,4a.43.43,0,0,1-.4.4H6.4a.43.43,0,0,1-.4-.4V12.4a.43.43,0,0,1,.4-.4H7.6a.43.43,0,0,1,.4.4Zm0-4a.43.43,0,0,1-.4.4H6.4A.43.43,0,0,1,6,9.6V8.4A.43.43,0,0,1,6.4,8H7.6a.43.43,0,0,1,.4.4Zm4,4a.43.43,0,0,1-.4.4H10.4a.43.43,0,0,1-.4-.4V8.4a.43.43,0,0,1,.4-.4h1.2a.43.43,0,0,1,.4.4v5.2Zm0-8a.43.43,0,0,1-.4.4H2.4A.43.43,0,0,1,2,5.6V2.4A.43.43,0,0,1,2.4,2h9.2a.43.43,0,0,1,.4.4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.03ad8f07616cc7680dcc5a4a9c46b5f6.svg";
export { ForwardRef as ReactComponent };